import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../../services/config.service';

export interface SystemConfiguration {
    configID?: number;
    configKey: string;
    configValue: string;
    configType: string;
    category: string;
    description?: string;
    isEncrypted: boolean;
    isActive: boolean;
    displayOrder: number;
}

export interface TestFreshdeskConnectionRequest {
    apiUrl: string;
    apiKey: string;
}

@Injectable({
    providedIn: 'root'
})
export class SystemSettingsService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService
    ) {}

    /**
     * Get all configurations for a specific category
     */
    getByCategory(category: string): Observable<any> {
        return this.http.get<any>(
            `${this.configService.get('apiBaseUrl')}/SystemConfiguration?category=${encodeURIComponent(category)}`
        ).pipe(map(response => response));
    }

    /**
     * Save multiple configurations at once
     */
    saveBatch(configs: SystemConfiguration[]): Observable<any> {
        return this.http.post<any>(
            `${this.configService.get('apiBaseUrl')}/SystemConfiguration/batch`,
            configs
        ).pipe(map(response => response));
    }

    /**
     * Test Freshdesk API connection
     */
    testFreshdeskConnection(request: TestFreshdeskConnectionRequest): Observable<any> {
        return this.http.post<any>(
            `${this.configService.get('apiBaseUrl')}/kaibugreport/test-freshdesk`,
            request
        ).pipe(map(response => response));
    }

    /**
     * Test Microsoft 365 Graph connection
     */
    testM365GraphConnection(): Observable<any> {
        return this.http.post<any>(
            `${this.configService.get('apiBaseUrl')}/SystemConfiguration/test-m365graph`,
            {}
        ).pipe(map(response => response));
    }
}
